import { render, staticRenderFns } from "./step-four.vue?vue&type=template&id=69b0c648&scoped=true&"
import script from "./step-four.vue?vue&type=script&lang=js&"
export * from "./step-four.vue?vue&type=script&lang=js&"
import style0 from "./step-four.vue?vue&type=style&index=0&id=69b0c648&lang=scss&scoped=scoped&"
import style1 from "./step-four.vue?vue&type=style&index=1&id=69b0c648&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69b0c648",
  null
  
)

export default component.exports